import { useIntl } from '@/intl'
import { DurationDropdownFilter } from '@/scopes/prices/components/Filters/DurationDropdownFilter'
import { GroupedAirportFilter } from '@/scopes/prices/components/Filters/GroupedAirportFilter'
import { MealPlanFilter } from '@/scopes/prices/components/Filters/MealPlanFilter'
import { ParticipantsDropdownFilter } from '@/scopes/prices/components/Filters/ParticipantsDropdownFilter'
import { RoomTypeFilter } from '@/scopes/prices/components/Filters/RoomTypeFilter'
import { TransportTypeFilter } from '@/scopes/prices/components/Filters/TransportTypeFilter'
import { getFiltersSelector, isAccommodationAvailableSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { mqMax, mqMin, space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Button, Dialog } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(234px, 1fr));
  column-gap: ${tokPx('primitives_space_24')};
  height: auto;
  width: 100%;
  background-color: ${tok('semantics_views_tinted_background_color')};
  border-radius: ${tokPx('semantics_boxes_corner_radius')};
  padding: ${space('primitives_space_24')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: 0;
    > * {
      margin-bottom: ${tokPx('primitives_space_12')};
    }
  }

  @media ${mqMax('primitives_breakpoint_s_max')} {
    padding-bottom: ${tokPx('primitives_space_20')};
  }
`

const ContentUnavailableWrapper = styled(Dialog)`
  margin: auto;
`

export function Filters() {
  const intl = useIntl()
  const { error } = usePricesSelector(getFiltersSelector)
  const { isFlightOnly } = usePricesSelector(isAccommodationAvailableSelector)

  if (error) {
    return (
      <ContentUnavailableWrapper
        icon="FaceSad"
        text={intl.formatMessage({ id: 'prices_filters_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_filters_error_message' })}
        type="custom"
        actionsSlot={(
          <Button onClick={() => window.location.reload()}>
            {intl.formatMessage({ id: 'prices_error_reload_button' })}
          </Button>
        )}
      />
    )
  }

  return (
    <Wrapper>
      <ParticipantsDropdownFilter isFlightOnly={isFlightOnly} />
      <DurationDropdownFilter />
      <GroupedAirportFilter />
      <RoomTypeFilter isFlightOnly={isFlightOnly} />
      <MealPlanFilter isFlightOnly={isFlightOnly} />
      <TransportTypeFilter isFlightOnly={isFlightOnly} />
    </Wrapper>
  )
}
